import { DEV_ENVIRONMENT_CONSTANTS } from '../constants/general';
import {
  OriginalTenantNames,
  Sanitized,
  SanitizedTenantNames,
} from '../types/plugins';

const plugins = [
  'azlist',
  'bettinggame',
  'crewtingcoffeebreak',
  'crewtingemployeefeedback',
  'eonservicenow',
  'faq',
  'feedbackcrew',
  'hypecast',
  'id-card',
  'ideation',
  'lidlflyer',
  'live',
  'movingimage',
  'movingimagelive',
  'octacornerstone',
  'orgnavigator',
  'poll',
  'quiz',
  'shareprice',
  'smartforms',
  'talk',
  'teaser',
  'thankyou',
  'ujkvibing',
  'usersync',
  'vnwnews',
  'wagdoclibrary',
  'whiterabbit',
  'wswdutyschedule',
  'wswladesaeule',
  'wswstempel',
  'vibecoding',
] as const;

export const PLUGINS = [...new Set(plugins)].sort();

export const instances = [1, 2, 3, 4] as const;
export const instanceKeys = instances.map(
  (entry) => `instance_${entry}` as const,
);
export const tenants = DEV_ENVIRONMENT_CONSTANTS.tenantData;

export const instanceValues = instances.map(
  (entry) => ({ name: `#${entry}` as const, num: entry }) as const,
);

export const sanitizedTenants = tenants.map(({ branch_id, branch_slug }) => {
  const sanitized = branch_slug.replace('.', '_').toLowerCase() as Sanitized<
    typeof branch_slug
  >;
  return {
    branch_id,
    branch_slug: sanitized,
  };
});

export const TENANT_NAMES: OriginalTenantNames[] = [
  'evil.corp',
  'ZORG.Industries',
];

/** Map tenant names to their sanitized counterparts (for example `evil.corp`
 *  to `evil_corp`) which are used in seed operations. */
export const tenantNamesMapper: {
  emulatorToSeed: Record<OriginalTenantNames, SanitizedTenantNames>;
  seedToEmulator: Record<SanitizedTenantNames, OriginalTenantNames>;
} = {
  emulatorToSeed: {
    'evil.corp': 'evil_corp',
    'ZORG.Industries': 'zorg_industries',
  },
  seedToEmulator: {
    evil_corp: 'evil.corp',
    zorg_industries: 'ZORG.Industries',
  },
};
